<script lang="ts">
    import Manager from "../application/models/Manager.ts";
    import Filter from "../application/models/Filter.ts";
    import {Select, Switch, Button} from 'svelma';
    import MenuSelect from "../presentationals/MenuSelect.svelte";
    import MenuHeader from "../presentationals/MenuHeader.svelte";
    import BackgroundElement from "../presentationals/BackgroundElement.svelte";
    import {_} from 'svelte-i18n';

    export let manager: Manager;
    export let filter: Filter;
    export let languages;
</script>

<BackgroundElement/>
<MenuHeader languages={languages}/>
<div class="columns p-2">
    <MenuSelect placeholder="{$_('menubar.tutors')}"
                dataArray={manager.tutorManager.getTutorsSorted()}
                filter={filter}
                store={"_tutorSelectValue"}/>

    <MenuSelect placeholder="{$_('menubar.rooms')}"
                dataArray={manager.classroomManager.getClassroomSorted()}
                filter={filter}
                store={"_roomSelectValue"}/>

    <MenuSelect placeholder="{$_('menubar.timetables')}"
                dataArray={manager.timetableManager.getTimetablesSorted()}
                filter={filter}
                store={"_timetableSelectValue"}/>

    <MenuSelect placeholder="{$_('menubar.weeks')}"
                dataArray={manager.dateManager.getWeeksArray()}
                filter={filter}
                store="_dateSelectValue"
                additionalText="{$_('menubar.weeksText')}"
                hasCounter={true}/>
</div>